<!--
Events screen
@author ab557z
-->

<template>
  <div id="contain" class="container">
    <Nav name="Events"/>
    <Spinner ref="spinner" />
      <div class="eventNavContainer">
        <ul class="eventNavUl nav nav-tabs" style="padding-left:0px !important;padding-right:0px !important;">
          <li @click="filterEvents('day')" class="eventNav" :class="{ dateActiveN: selected[0] }">
            Today
          </li>
          <li @click="filterEvents('week')" class="eventNav" :class="{ dateActiveN: selected[1] }">
            Next 7 days
          </li>
          <li @click="filterEvents('beyond')" class="eventNav" :class="{ dateActiveN: selected[2] }">
            Beyond
          </li>
        </ul>
      </div>
      <div class="eventsFilter" >
        <select class="filterSelect" @change="addCategoryFilter()" v-model="filterCategory">
          <option value=-1>All Categories</option>
          <option v-bind:key="c.id" :value="c.id" v-for="c in categories" >{{ c.name }}</option>
        </select>
      </div>
      <div v-if="results.length == 0" class="eventsNone">
        No events <span v-if="filterCategory != -1">(events are also currently filtered by category above)</span>
      </div>
      <div v-if="results.length > 0" style="margin-top:8px;margin-left:24px;margin-right:24px;">
        <Event v-for="(event) in results"
                  :ref="(element) => {eventElements['event'+event.id] = element}"
                  :event="event"
                  :key="event.id" :title="event.title" :facebook="event.facebook" :startDate="event.startDate"
                  :startTime="event.startTime" :endDate="event.endDate" :endTime="event.endTime" :loc="event.location"
        />
      </div>

    <div id="pusher"></div>
    <Footer active="events"/>
  </div>
</template>

<script setup>
//Utilities
import { ref, computed, onMounted, nextTick } from 'vue'
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

//Composables
import { useStringUtil } from '@/composables/StringMethods.js'
const {isEmpty} = useStringUtil()

//Components
import Event from '@/components/events/NewEvent.vue'
// import ExpandedEvent from '@/components/events/ExpandedEvent.vue'
import Footer from '@/components/FooterMenu.vue'
import Spinner from '@/components/Spinner.vue'

//Data
const results = ref({})
const selected = ref([true, false, false])
const filterCategory = ref(-1)
const categories = ref([])
const events = ref(null)

//Component refs
const eventElements = ref({})
const spinner = ref(null)

//Computed
const view = computed(
  () => {
    if (this.selected[0] === true) {
        return 'day'
      }
      if (this.selected[1] === true) {
        return 'week'
      }
      return 'beyond'
  }
)

onMounted(
  () => {
    getCategories()
    getEvents()
  }
)

function scrollMeTo (refName) {

  const elRef = eventElements.value[refName].eventBox

  if (typeof elRef !== 'undefined') {
    //let element = elRef.$el
    // var top = element.offsetTop
    // window.scrollTo(0, top)
    elRef.scrollIntoView(true)
  } else {
        // console.log('marker not found')
  }
}

function getCategories () {
  axios.get('/timetable/events/categories', { withCredentials: true })
    .then(response => {
      categories.value = response.data
      // console.log(this.events)
    })
}

function getEvents () {
  spinner.value.spin()
  axios.get('/timetable/events/upcoming', { withCredentials: true })
    .then(response => {
      events.value = response.data
      // console.log('Number of events: ' + this.events.length)
      spinner.value.stop()
      const savedELType = lst.getValue('eventListType')
          // console.log('savedELType')
          // console.log(savedELType)
      if (!isEmpty(savedELType) && savedELType != 'null') {
        filterEvents(savedELType)
      } else {
        filterEvents('day')
      }
      nextTick(() => {
        if (lst.getValue('lastEvent')) {
          const lastEventJson = JSON.parse(lst.getValue('lastEvent'))
          scrollMeTo('event' + lastEventJson.id)
          lst.deleteValue('lastEvent')
        }
      })
    })
}

function nullProtect (tme) {
  return isEmpty(tme) ? '00:00' : tme
}

function sortEvents () {
  results.value.sort(function (x, y) {
    // set to js date objects
    var e1 = new Date(x.startDate)
    var e2 = new Date(y.startDate)

    // start on different days so return appropriate
    if (e1 < e2) return -1
    if (e1 > e2) return 1

    // start on same day, so sort by start times
    // some of the events don't have start or end times so guard against this (see comment 23/11/21 on WCSC-1381)
    let xStartTime = nullProtect(x.startTime)
    let xEndTime = nullProtect(x.endTime)
    let yStartTime = nullProtect(y.startTime)
    let yEndTime = nullProtect(y.endTime)
    if (xStartTime < yStartTime) return -1
    if (xStartTime > yStartTime) return 1

    // if start times are the same
    var e1End = new Date(x.endDate)
    var e2End = new Date(y.endDate)
    // end on different day, so ignore end times
    if (e1End < e2End) return -1
    if (e1End > e2End) return 1
    // if end on same day, figure out the times
    if (xEndTime < yEndTime) return -1
    if (xEndTime > yEndTime) return 1

    // exactly the same so dont sort !
    return 0
  })

  const timeNow = new Date()
  // var time = ('0' + timeNow.getHours()).slice(-2) + ':' + ('0' + timeNow.getMinutes()).slice(-2)
  // time = time.toString()
  timeNow.setHours(0, 0, 0, 0)
  const tomorrow = new Date()
  tomorrow.setHours(0, 0, 0, 0)
  tomorrow.setDate(tomorrow.getDate() + 1)
  const yesterday = new Date()
  yesterday.setHours(0, 0, 0, 0)
  yesterday.setDate(yesterday.getDate() - 1)
  for (var i = 0; i < results.value.length; i++) {
    var e = results.value[i]
    //  if (e.endTime < time && (new Date(e.endDate) >= timeNow && new Date(e.endDate) < tomorrow)) {
    if (nullProtect(e.endTime) < yesterday) {
      const index = results.value.indexOf(e)
      results.value.splice(index)
    }
  }
}

function addCategoryFilter () {
  // this is another filter - filterEvents does the job so changing the dropdown will just trigger it
  filterEvents(view)
}

function filterEvents (type) {
  const dateNow = new Date()
  const dayFromNow = new Date()
  const weekFromNow = new Date()
  dateNow.setHours(0, 0, 0, 0)
  dayFromNow.setHours(0, 0, 0, 0)
  weekFromNow.setHours(0, 0, 0, 0)
  dayFromNow.setDate(dateNow.getDate() + 1)
  weekFromNow.setDate(dateNow.getDate() + 7)
  results.value = events.value

  // work out where to display each event

  results.value.map(e => {
    const evSDate = new Date(e.startDate)
    const evEDate = new Date(e.endDate)
    // console.log('comparing dateNow: ' + dateNow + ' and evSDate: ' + evSDate + ' and dayFromNow: ' + dayFromNow)
    if (dateNow <= evSDate && evSDate < dayFromNow) {
      e.dispTime = 'day'
    } else if (dayFromNow <= evSDate && evSDate < weekFromNow) {
      e.dispTime = 'week'
    } else if (weekFromNow <= evSDate) {
      e.dispTime = 'beyond'
    } else { // it's in the past. base display on the end date as per WCSC-1497
      if (evEDate >= dateNow) {
        e.dispTime = 'day'
      } else {
        e.dispTime = 'PAST'
      }
    }
  })

  selected.value = [type === 'day', type === 'week', type === 'beyond']
  lst.setValue('eventListType', type)
  results.value = results.value.filter(e => e.dispTime == type)

  /* if (type === 'day') {
    this.selected = [true, false, false]
    $cookies.set('eventListType', 'day', 0)
    this.results = this.results.filter(e => e.dispTime == 'day')
  } else if (type == 'week') {
    this.selected = [false, true, false]
    $cookies.set('eventListType', 'week', 0)
    this.results = this.events.filter(e => e.dispTime == 'week')
  } else {
    $cookies.set('eventListType', 'beyond', 0)
    this.selected = [false, false, true]
    this.results = this.events.filter(e => e.dispTime == 'beyond')
  } */
  if (filterCategory.value != -1) {
    // console.log('filtering on category id ' + this.filterCategory + ' ...')
    results.value = results.value.filter(e => e.categories.map(c => c.id).includes(filterCategory.value))
    if (filterCategory.value != -1) {
      console.log('filtering on category id ' + filterCategory.value + ' ...')
      results.value = results.value.filter(e => e.categories.map(c => c.id).includes(filterCategory.value))
    }
    sortEvents()
  }
}
</script>

<style scoped lang="scss">
.eventsFilter {
  width: 100%;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 20px;
  padding-bottom:10px;
}
.filterSelect {
  width: 100%;
  font-size: 18px;
  background: rgba(118, 118, 128, 0.12);
  border-radius: 10px;
  border: none;
  padding:3px;
}
.eventsNone {
  margin-top:15px;
  text-align: center;
  color: #aaa;
}
.eventNavContainer {
  overflow:hidden;
  display: inline;
  white-space:nowrap;
}
.eventNavUl::-webkit-scrollbar {
  display: none;
}

.eventNav {
    width: 33.3333% !important;
    /* below inherits from another .eventNav */
    /*text-align: center;
    line-height: 50px;
    height: 50px;*/
}

.dateActiveN {
  border-bottom: 4px solid #951272;
  color: #951272 !important;
  font-weight:900;
}
.eventNavUl {
  padding-left:0px !important;
  margin-left:0px !important;
  margin-right:0px !important;
  border-bottom:0px !important;
  overflow-x:auto;
  overflow-y:hidden;
  white-space: nowrap;
  background-color: #F0F1F1;
  -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
li.eventNav {
  padding-left:20px;
  padding-right:20px;
  text-align:center;
  line-height: 50px;
  color:#003865;
  font-weight:700;
  height: 50px;
}

.notifActionText {
  float:left;
  margin-left:16px;
  margin-top:32px;
  color:#4F5961;
}

</style>
